import { styled } from '@mui/material/styles';
import { Paper, Typography } from '@mui/material';

// ─── Page shell ───────────────────────────────────────────────────────────────

export const PageWrapperStyled = styled('div', {
  name: 'ProductInvoicing_PageWrapper',
})(({ theme }) => ({
  padding: theme.spacing(2, 0, 4),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2.5),
}));

export const DescriptionStyled = styled(Typography, {
  name: 'ProductInvoicing_Description',
})(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

// ─── Filter card ──────────────────────────────────────────────────────────────

export const FilterCardStyled = styled(Paper, {
  name: 'ProductInvoicing_FilterCard',
})(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2.5),
  padding: theme.spacing(3),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  boxShadow: 'none',
}));

export const FilterColumnsStyled = styled('div', {
  name: 'ProductInvoicing_FilterColumns',
})(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(4),
  alignItems: 'flex-start',
  flexWrap: 'wrap',
}));

export const FilterColumnStyled = styled('div', {
  name: 'ProductInvoicing_FilterColumn',
})(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2.5),
  flex: '1 1 320px',
  minWidth: 280,
}));

export const CheckboxRowStyled = styled('div', {
  name: 'ProductInvoicing_CheckboxRow',
})(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginTop: theme.spacing(-1),
}));

export const ActionsRowStyled = styled('div', {
  name: 'ProductInvoicing_ActionsRow',
})(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1.5),
  justifyContent: 'flex-end',
  flexWrap: 'wrap',
}));
